(()=>{
 if(window.senecaEnquiryReady)return;window.senecaEnquiryReady=true;
 const params=new URLSearchParams(location.search);
 const clean=k=>(params.get(k)||'').replace(/[\r\n<>]/g,' ').trim().slice(0,300);
 const product=clean('product'),application=clean('application');
 const type=clean('enquiry')==='finance'?'Rental enquiry':product?'Product enquiry':params.has('sims')?'SIM plan enquiry':'General enquiry';
 // Keep all shop enquiry links on the same contact route and preserve context.
 document.querySelectorAll('a[href]').forEach(a=>{
  const u=new URL(a.href,location.origin);
  if((u.hostname==='senecaenterprise.com'&&u.pathname==='/contact/')||(u.origin===location.origin&&u.pathname==='/pages/contact')){
   u.protocol=location.protocol;u.host=location.host;u.pathname='/pages/contact';
   if(location.pathname.startsWith('/products/')&&!u.searchParams.has('product'))u.searchParams.set('product',document.querySelector('h1')?.textContent.trim()||'');
   if(location.pathname.includes('/sim-cards-')&&!u.searchParams.has('application'))u.searchParams.set('application',document.querySelector('h1')?.textContent.trim()||'');
   a.href=u.pathname+u.search+u.hash;
  }
 });
 document.querySelectorAll('form.seneca-standard-form').forEach(form=>{
  const box=form.querySelector('textarea[name="your-message"]');if(!box)return;
  const parts=[];
  if(product)parts.push('Product: '+product);
  if(application)parts.push('Application: '+application);
  const n=Number(params.get('sims')),g=Number(params.get('gb')),t=params.get('term');
  if(params.has('sims')&&params.has('gb')&&['payg','m24'].includes(t)&&Number.isInteger(n)&&n>=1&&n<=100000&&Number.isFinite(g)&&g>=.5){
   parts.push(`${n} SIM${n===1?'':'s'} · ${g} GB shared monthly`,`Term: ${t==='payg'?'PAYG, monthly rolling with 30 days’ notice':'24 months'}`);
   try{
    const q=SenecaPricing.quote(n,g),p=q[t],money=v=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(v);
    parts.push(p.poa?'POA: please quote':`Indicative monthly total: ${money(p.incVat)} including VAT (${money(p.price)} excluding VAT)`);
    if(t==='m24')parts.push('SIM card included for 24-month plans.');
    else if(!p.poa)parts.push(`One-off SIM charge: ${money(q.upfront*1.2)} including VAT`);
    parts.push('Additional usage beyond your shared monthly pool: £4 per GB including VAT.','Final pricing and terms to be confirmed before activation.');
   }catch(e){parts.push('Please confirm pricing for this configuration.');}
  }
  const details=[location.pathname==='/'?'Deployment enquiry':type,...parts].join('\n');
  if(parts.length&&!box.value.trim())box.value=details+'\n\nMy requirements:\n';
  form.addEventListener('submit',async event=>{
   event.preventDefault();
   const button=form.querySelector('button[type="submit"]'),status=form.querySelector('.seneca-form-status');
   if(button.disabled||!form.reportValidity())return;
   button.disabled=true;button.textContent='Sending…';status.textContent='';
   const data=new FormData(form);
   data.set('_wpcf7','1547');data.set('_wpcf7_version','6.1.7');data.set('_wpcf7_locale','en');
   data.set('_wpcf7_unit_tag','wpcf7-f1547-p59-o1');data.set('_wpcf7_container_post','59');data.set('_wpcf7_posted_data_hash','');
   data.set('your-context',details);data.set('your-source',location.origin+location.pathname);
   try{
    const response=await fetch(form.action,{method:'POST',body:data,credentials:'omit',signal:AbortSignal.timeout(30000)});
    if(!response.ok)throw new Error('Request failed');
    const result=await response.json();
    if(result.status!=='mail_sent'){
     status.textContent=result.status==='validation_failed'?'Please check your name, email and message.': 'Your enquiry could not be sent. Please try again or call +44 (0)151 453 5915.';
     return;
    }
    status.textContent='Thank you. Your enquiry has been sent to Seneca.';
    form.reset();if(parts.length)box.value=details+'\n\nMy requirements:\n';
    if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()&&typeof window.gtag==='function')window.gtag('event',params.has('seo_test')?'seo_test_lead':'generate_lead',{site:'shop',form:'contact'});
   }catch(error){status.textContent='We could not confirm delivery. Please call +44 (0)151 453 5915, or try again.';}
   finally{button.disabled=false;button.textContent='Send enquiry';}
  });
 });
})();
